import React from "react";
import { AskAiButton } from "@oppizi-ecosystem/copilot";

import { authorization } from "../module/auth";

/**
 * "Ask AI Assistant" launcher for the global Copilot chat, rendered in each
 * header's right slot. It is the library's <AskAiButton> pill (sparkle, label,
 * animated ring — the oppizi.com one), which toggles the shared panel through
 * context. `sm` (32px) so it sits inside every header this app has (72–80px)
 * next to the 36px theme toggle / avatar without stretching a row.
 *
 * Gated on the same authorization.isClient() check as the <ClientChat> provider it
 * drives, so the button always has a <CopilotProvider> ancestor (the shipped button
 * throws outside one) and non-client/unauth users never see a launcher.
 */
const CopilotLauncher = () => {
  if (!authorization.isClient()) return null;

  return <AskAiButton cypressId="copilotLauncher" size="sm" />;
};

export default CopilotLauncher;
